<template>
  <nav class="about-menu-nav">
    <ul class="about-menu-nav__list">
      <AboutMenuNavItem v-for="item in navigationItems" :key="item.id" v-bind="item" @select="emit('select')" />
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

import AboutMenuNavItem from './AboutMenuNavItem.vue';

import type { AboutMenuNavBaseItem, AboutMenuNavItemProps } from '../model/types.ts';

interface Props {
  items: AboutMenuNavBaseItem[];
}

const props = defineProps<Props>();

const navigationItems = computed<AboutMenuNavItemProps[]>(() =>
  props.items.map((item) => ({
    ...item,
    component: item.type === 'content-page' ? RouterLink : 'a',
    componentProps:
      item.type === 'content-page'
        ? {
            to: item.href,
          }
        : {
            href: item.href,
            rel: 'noopener',
          },
  })),
);

const emit = defineEmits<{
  select: [];
}>();
</script>

<style scoped lang="scss">
.about-menu-nav {
  width: 100%;
}

.about-menu-nav__list {
  display: flex;
  flex-direction: column;
  gap: var(--alias-space-16);
  padding: 0;
  margin: 0;
  list-style-type: none;

  @include adaptivity.tablet {
    gap: var(--alias-space-12);
  }
}
</style>
